import { FolderKanban, Plane, Receipt, ShoppingCart, Users, type LucideIcon } from 'lucide-react';
import type { Permission } from '@proerp/shared';

/**
 * Schnellaktionen „etwas Neues anlegen": springen auf die Seite und öffnen dort
 * per `?neu=1` den Anlegen-Dialog (`useOpenOnParam`). Nur sichtbar mit dem
 * passenden Anlege-Recht.
 *
 * Eine Liste für zwei Stellen — die Befehls-Palette (⌘K) und den „+"-Knopf der
 * mobilen Leiste (`MobileDock`, 2026-09-24). Getrennt gepflegt liefen sie
 * auseinander; wer hier eine Aktion ergänzt, hat sie an beiden Stellen.
 */
export interface QuickAction {
  id: string;
  label: string;
  /** Kurzbeschreibung unter dem Label (mobiles „+"-Sheet). */
  hint: string;
  keywords: string;
  icon: LucideIcon;
  route: string;
  permission: Permission;
}

export const QUICK_ACTIONS: QuickAction[] = [
  { id: 'action:sales', label: 'Beleg anlegen (Verkauf)', hint: 'Angebot, Auftrag, Rechnung …', keywords: 'beleg angebot rechnung auftrag verkauf neu', icon: Receipt, route: '/verkauf?neu=1', permission: 'sales.create' },
  { id: 'action:project', label: 'Neues Projekt', hint: 'Projekt anlegen', keywords: 'projekt anlegen neu', icon: FolderKanban, route: '/projekte?neu=1', permission: 'projects.create' },
  { id: 'action:customer', label: 'Neuer Kunde / Lieferant', hint: 'Eintrag im CRM', keywords: 'kunde lieferant kontakt crm neu', icon: Users, route: '/crm?neu=1', permission: 'crm.create' },
  { id: 'action:purchase', label: 'Neue Bestellung (Einkauf)', hint: 'Bestellung beim Lieferanten', keywords: 'bestellung einkauf anfrage lieferant neu', icon: ShoppingCart, route: '/beschaffung?neu=1', permission: 'procurement.create' },
  { id: 'action:travel', label: 'Reisekosten erfassen', hint: 'Neue Reise anlegen', keywords: 'reise reisekosten spesen diaeten neu', icon: Plane, route: '/reisekosten?neu=1', permission: 'travel.create' },
];
